'use client'

import { cn } from '@repo/ui/lib'
import { Eye, EyeOff } from 'lucide-react'
import * as React from 'react'
import { useState } from 'react'

import { Button } from './button.tsx'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  startIcon?: React.ReactNode
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, startIcon, type, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false) // State to manage password visibility
    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword)
    }

    return (
      <div className={'relative w-full'}>
        <input
          className={cn(
            'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
            'focus-visible:outline-brand',
            startIcon && 'ps-8',
            className,
          )}
          ref={ref}
          type={type === 'password' && showPassword ? 'text' : type}
          {...props}
        />
        {type === 'password' && (
          <Button
            className={'absolute right-0 top-0'}
            onClick={togglePasswordVisibility}
            size={'icon'}
            type={'button'}
            variant={'ghost'}
          >
            {showPassword ? <EyeOff /> : <Eye />}
          </Button>
        )}
        {startIcon && (
          <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 text-muted-foreground/80 peer-disabled:opacity-50">
            {startIcon}
          </div>
        )}
      </div>
    )
  },
)
Input.displayName = 'Input'

export { Input }
